import { cn } from "@/lib/utils";

interface LogoProps {
  variant?: "full" | "icon";
  size?: "sm" | "md" | "lg";
  theme?: "auto" | "light" | "dark" | "colorful";
  className?: string;
  onClick?: () => void;
}

export function Logo({ variant = "icon", size = "md", theme = "colorful", className, onClick }: LogoProps) {
  const sizeClasses = {
    sm: variant === "full" ? "h-8" : "h-8 w-8",
    md: variant === "full" ? "h-12" : "h-10 w-10",
    lg: variant === "full" ? "h-16" : "h-12 w-12"
  };

  const textSizes = {
    sm: "text-lg",
    md: "text-xl",
    lg: "text-2xl"
  };

  const getLogoSrc = () => {
    // Determine the theme suffix for the logo file
    let themeSuffix = "";
    if (theme !== "colorful" && theme !== "auto") {
      themeSuffix = `-${theme}`;
    }

    // For icon variant, use the icon-specific SVG files
    const variantPrefix = variant === "icon" ? "-icon" : "";

    return `/logo${variantPrefix}${themeSuffix}.svg`;
  };

  const logoSrc = getLogoSrc();
  const altText = "monelab logo";

  if (variant === "full") {
    return (
      <div
        className={cn(
          "flex items-center gap-2 transition-transform duration-200",
          onClick && "cursor-pointer hover:scale-105",
          className
        )}
        onClick={onClick}
      >
        <img
          src={logoSrc}
          alt={altText}
          className={cn(
            "h-8 w-8 transition-transform duration-200",
            onClick && "cursor-pointer hover:scale-105"
          )}
        />
        <span className={cn(
          "font-bold text-blue-950",
          textSizes[size]
        )}>
          mono<span className="text-primary font-extrabold">lab</span>
        </span>
      </div>
    );
  }

  return (
    <img
      src={logoSrc}
      alt={altText}
      className={cn(
        sizeClasses[size],
        "transition-transform duration-200",
        onClick && "cursor-pointer hover:scale-105",
        className
      )}
      onClick={onClick}
    />
  );
}
